import React from 'react';
import { CloseWhiteIcon, EmergencyIcon, EmergencyHomeIcon } from '@util/svgicon';
import HeartLoss from '@images/heart_loss.png';
import { PermanentBenRules, ResultRules } from '@util/config';

const RulesModel = ({ closeRulesModelHandler }) => {

    return (
        <div className='w-full h-full overflow-auto p-[36px]'>
            <div className='flex'>
                <button className='flex pl-[8px] pr-[12px] py-[6px] items-start gap-[6px] rounded-[1000px] bg-[#000]' onClick={closeRulesModelHandler}>
                    <CloseWhiteIcon />
                    <p className='text-[#FAFAFA] text-[16px] not-italic font-semibold leading-[normal] tracking-[-0.64px]'>Close</p>
                </button>
            </div>
            <div className='flex flex-col items-center gap-[48px]'>
                <div className='flex flex-col justify-center items-center gap-[24px] w-[600px]'>
                    <img src={HeartLoss} alt='heartLoss image' />
                    <div className='flex items-center gap-[12px]'>
                        <p className='text-[#000] text-[42px] not-italic font-bold leading-[42px] tracking-[-1.68px]'>Rules and Warnings:</p>
                    </div>
                    <p className='text-[#737373] text-[18px] not-italic font-medium leading-[28px] tracking-[-0.72px]'>FrodoBots offers the privilege of autonomously visiting regions; however, harmful actions lead to warnings. Getting 3 warnings results in a permanent ban from the FrodoBots service.</p>
                    <p className='text-[#737373] text-[18px] not-italic font-medium leading-[28px] tracking-[-0.72px]'>Below are rules to ensure a positive experience for all:</p>
                </div>
                <div className='flex flex-col justify-center gap-[24px] w-full'>
                    <div className='flex justify-center items-center gap-[12px] w-full'>
                        <EmergencyIcon />
                        <p className='text-[#000] text-center text-[20px] not-italic font-semibold leading-[24px] tracking-[-1.2px]'>These violations will result in a permanent ban.</p>
                    </div>
                    <div className='flex justify-center items-center content-start gap-[24px] flex-wrap w-[80%] m-auto'>
                        {
                            PermanentBenRules.map((i) => (
                                <div className='flex w-[500px] h-[200px] min-w-[300px] p-[16px] flex-col items-start gap-[16px] rounded-[16px] border-[2px] border-[solid] border-[#FF1053] bg-[#FFF]'>
                                    {i.icon}
                                    <p className='text-[#000] text-[20px] not-italic font-semibold leading-[24px] tracking-[-1.2px]'>{i.title}</p>
                                    <p className='text-[#737373] text-[14px] not-italic font-medium leading-[18px] tracking-[-0.56px]'>{i.description}</p>
                                </div>
                            ))
                        }
                    </div>
                    <div className='flex justify-center items-center gap-[12px] w-full'>
                        <EmergencyHomeIcon />
                        <p className='text-[#000] text-center text-[20px] not-italic font-semibold leading-[24px] tracking-[-1.2px]'>These violations will result in a warning.</p>
                    </div>
                    <div className='flex justify-center items-start content-start gap-[24px] flex-wrap w-[80%] m-auto'>
                        {
                            ResultRules.map((i) => (
                                <div className='flex w-[500px] h-[200px] min-w-[300px] p-[16px] flex-col items-start gap-[16px] rounded-[16px] bg-[#FFF]'>
                                    {i.icon}
                                    <p className='text-[#000] text-[20px] not-italic font-semibold leading-[24px] tracking-[-1.2px]'>{i.title}</p>
                                    <p className='text-[#737373] text-[14px] not-italic font-medium leading-[18px] tracking-[-0.56px]'>{i.description}</p>
                                </div>
                            ))
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default RulesModel;